<section class="company-section">
  <div class="container">
    <div appAnimateOnScroll="fade-in-up">
      <h2 class="section-title">
        <span>{{ 'company.WE_ARE_ONE' | translate }}</span>&nbsp;
        <span class="highlighted">{{ 'company.TECHNOLOGY_COMPANY' | translate }}</span>&nbsp;
        <span>{{ 'company.FOCUSED_ON_PEOPLE' | translate }}</span>
      </h2>
    </div>
    <div class="row">
      @for (card of companyCards; track card; let i = $index) {
        <div class="col-lg-3 col-md-6 mb-4" appAnimateOnScroll="fade-in-up" [style.transition-delay.ms]="i * 150">
          <div class="company-card">
            <div class="icon-container">
              <svg class="semicircle-pair" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="39.5" stroke="#BFDBFE" stroke-dasharray="2 2"/>
              </svg>
              <img [src]="card.icon" class="icon-child" [alt]="card.title | translate">
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ card.title | translate }}</h3>
              <div class="card-description">
                <p>{{ card.description | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>